import React, { Fragment, useEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import { Row, Dropdown, Menu, Tag, DatePicker, Popover, Col, Card, Divider, Button, Input, Modal, Tabs, Select, Drawer, message, Checkbox, Form, Spin, Table } from "antd";
import {
  SearchOutlined,
  ArrowLeftOutlined,
  ExclamationCircleOutlined,
  CloseOutlined,
  SyncOutlined,
  LoadingOutlined,
  CheckCircleTwoTone,
  ExclamationCircleTwoTone,
  DownOutlined,
  RightOutlined,
  CheckCircleOutlined,
  CalendarOutlined,
  EyeOutlined,
  ShoppingCartOutlined,
  CreditCardOutlined,
  UserOutlined,
  MoreOutlined,
  PrinterOutlined,
  EllipsisOutlined,
  CloseCircleOutlined,
  PhoneOutlined,
} from "@ant-design/icons";
import Back from "../../../assets/images/backIcon.svg";
import db from "../../../database";
import useTransactionStore from "../../../stores/useTransactionStore";
import "./index.css";
import { Scrollbars } from "react-custom-scrollbars";
import { useTranslation } from "react-i18next";
import Keyboard from "react-simple-keyboard";
import sortBy from "lodash/sortBy";
import CustomerSearch from "../../../assets/images/c-serach.svg";
import HCPrint from "../../../lib/printer/hardWareControllerPrinter";
import { useEventBus } from "../../../lib/components/EventBusProvider";
import CWHCPrint from "../../../lib/printer/CWHardwareController";
import { htmlPrint } from "../../../lib/printer/htmlPrinter";
import { xmlPrint } from "../../../lib/printer/xmlPrinter";
import printerIcon from "../../../assets/images/printerIcon.svg";
import { getOAuthHeaders } from "../../../constants/oAuthValidation";
import Discard from "../../../assets/images/return.png";
import clearFilters from "../../../assets/images/clearFilters.svg";
import closeX from "../../../assets/images/close-x.svg";
import { orderHistoryService, cancelPreorder } from "../../../services";
import { stock } from "../../PointOfSale/Core/stock";
import { v4 as uuidv4 } from "uuid";
import messages from "../../../errors/messages.en-IN.json";
import { getWorkflowData } from "../../../utils/getWorkflowData";
import usePOSConfigStore from "../../../stores/usePOSConfigStore";
import useSessionStore from "../../../stores/useSessionStore";
import dayjs from "dayjs";
import { trace } from "../../../utils/debugTrace";
import useCartStore from "../../../stores/useCartStore";

const ManagePreorder = (props) => {
  const { dispatchEvent, dispatchItemSelection } = useEventBus();
  const {
    isLocked,
    setIsLocked,
    isSectionVisible,
    setIsSectionVisible,
    showPreOrders,
    setShowPreOrders,
    searchOrderHistory,
    dateRange,
    setDateRange,
    setIsInputFocused,
    isInputFocused,
    searchHistoryInput,
    setSearchhistoryInput,
    keyboard,
    orderHistoryDetails,
    setOrderHistoryDetails,
    selectedKeys,
    setSelectedKeys,
    tillData,
    setStartRowData,
    startRowData,
    setOrdersCopy,
    ordersCopy,
    expandedRowKeys,
    setExpandedRowKeys,
    getSalesHistoryData,
    isPrintModeXML,
    upsertPOSLog,
    filterdParkedList,
    setFilterdParkedList,
    prevHistoryRef,
    setCheckedKeys,
    checkedKeys,
    retrunSearchType,
    setReturnSearchType,
    loading,
    setLoading,
    documentTypes,
    setShowDocumentPopup,
    getFilteredPaymentMethods,
    setStartIndex,
    startIndex,
    cart,
    parkBill,
    selectLayAwayOrder,
    selectedDocumentType,
    setSelectedDocumentType,
    selectedSaleTypeData,
    setSelectedSaleTypeData,
    showPayments,
    setShowPayments,
    selectedSaleType,
    setSelectedSaleType,
    filtersFlag,
    setFiltersFlag,
    inputName,
    setInputName,
    open,
    setOpen,
    setFilterdDate,
    setCart,
    setProductStock,
    setSelectedProductInCart,
    setShowPaymentMethods,
    metaDataRef,
    setTempCart,
    tempCart,
    showCompleteSaleStock,
    setShowCompleteSaleStock,
    completeSaleStockData,
    setCompleteSaleStockData,
  } = props;
  const history = useHistory();
  let searchCustomersRef = useRef();
  // Holds the timeout id for debounced customer/document search so that typing
  // triggers filtering without requiring the cashier to press Enter.
  const preorderSearchDebounceRef = useRef(null);
  const { RangePicker } = DatePicker;
  const [isReturn, setIsReturn] = useState(false);
  const scrollbarsRef = useRef(null);
  const dateRef = useRef(null);
  const debounceTimeoutRef = useRef(null);
  const [maxScroll, setMaxScroll] = useState(0);
  const [currentScroll, setCurrentScroll] = useState(0);
  const [scrollLeft, setScrollLeft] = useState(0);
  const [activeTab, setActiveTab] = useState("All Orders");
  const posConfig = usePOSConfigStore((s) => s.posConfig);
  const [historyDetails, setHistoryDetails] = useState([]);
  const [isPopoverVisible, setPopoverVisible] = useState(false);
  const [viewDetails, setViewDetails] = useState(false);
  const [recordId, setRecordId] = useState(null);
  const [recordDetails, setRecordDetails] = useState([]);
  const colorVariable = process.env.REACT_APP_POSBACKGROUND_COLOR;
  const pricePrecision = tillData.tillAccess.csBunit.currencies[0].prcPrecision;
  const currenciesList = tillData.tillAccess.csBunit.currencies;
  const themeJSON = posConfig?.themeJSON && posConfig?.themeJSON !== "N" && Object.keys(posConfig?.themeJSON).length > 0 ? JSON.parse(posConfig?.themeJSON)?.layout4 : {};
  const ObFlag = tillData.tillAccess.cwrTill.printTemplate.obController === "Y" ? true : false;
  const CWHardwareController = tillData.tillAccess.cwrTill.printTemplate.cwController === "Y" ? true : false;
  const mainDivStyles = themeJSON.appBgImageURL
    ? { backgroundImage: `url(${themeJSON.appBgImageURL})`, height: "100vh", width: "100%", display: isLocked || isSectionVisible ? "none" : "block" }
    : { backgroundColor: colorVariable ? colorVariable : "#f3f4f9", height: "100vh", width: "100%", display: isLocked || isSectionVisible ? "none" : "block" };
  document.querySelectorAll("amt-dial-btn-market").forEach((element) => {
    element.style.backgroundColor = themeJSON.keyBoardColor;
  });
  const [deliveryDateRange, setDeliveryDateRange] = useState([]);
  const [deliveryPopoverVisible, setDeliveryPopoverVisible] = useState(false);
  // delivery date filter removed (BUG-1123) — only order date filter is used

  let reconstructedObject;
  const rawtillAccessMeta = tillData?.tillAccess?.tillAccessMeta;
  if (rawtillAccessMeta) {
    const rawDataArray = tillData?.tillAccess?.tillAccessMeta;
    const printObject = rawDataArray.find((item) => item.key === "Print");
    const printObjectValue = printObject?.value;
    if (printObjectValue !== undefined) {
      const cleanedData = printObjectValue.replace(/[{}"]/g, "");

      const keyValuePairs = cleanedData.split(",");

      reconstructedObject = {};
      keyValuePairs.forEach((pair) => {
        if (pair.includes(":")) {
          const [key, value] = pair.split(":");

          if (key !== undefined && value !== undefined) {
            reconstructedObject[key.trim()] = value.trim();
          }
        }
      });
    } else {
      console.error("printObjectValue is undefined");
    }
  }

  const tabs = ["All Orders", "Pre-Orders", "Completed", "Returned", "Cancelled"];

  const handleTabClick = (tab) => {
    if (tab === "Pre-Orders") {
      const layawayOrders = historyDetails.filter((item) => item.type === "Layaway");
      setOrderHistoryDetails(layawayOrders);
    } else if (tab === "Returned") {
      const returnOrders = historyDetails.filter((item) => item.type === "Return");
      setOrderHistoryDetails(returnOrders);
    } else if (tab === "Cancelled") {
      const cancelledOrders = historyDetails.filter((item) => item.type === "Cancelled");
      setOrderHistoryDetails(cancelledOrders);
    } else if (tab === "Completed") {
      const completedOrders = historyDetails.filter((item) => item.type === "Receipt");
      setOrderHistoryDetails(completedOrders);
    } else {
      setOrderHistoryDetails(historyDetails);
    }
  };

  const columns = [
    {
      title: "Item",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Quantity",
      dataIndex: "weight",
      key: "weight",
    },
    {
      title: "Price",
      dataIndex: "salePrice",
      key: "salePrice",
      // render: (price) => `₹${price?.toFixed(2)}`,
    },
    {
      title: "Total",
      dataIndex: "nettotal",
      key: "nettotal",
      // render: (total) => `₹${total?.toFixed(2)}`,
    },
  ];

  const selectCompleteLayAwayOrder = async (item, fieldName) => {
    trace("CartDiag", "selectCompleteLayAwayOrder entry", { itemsLen: item?.items?.length, preOrder: item?.preOrder, layAway: item?.layAway, paid: item?.paid, total: item?.total, sOrderID: item?.sOrderID });
    const itemWithNumberTotal = {
      ...item,
      total: parseFloat(item.total),
    };
    const customMixEntry = metaDataRef.current.find((entry) => entry.key === "Custom Mix");
    let updatedCart;
    if (!customMixEntry) {
      updatedCart = {
        ...itemWithNumberTotal,
      };
    } else {
      let customMixData = [];
      try {
        customMixData = JSON.parse(customMixEntry.value);
      } catch (error) {
        console.error("Invalid JSON in Custom Mix value", error);
        return [];
      }
      const matchedIds = new Set();
      const enrichedMixes = customMixData.map((mix) => {
        const matchedChildren = mix.children
          .map((child) => {
            const matchedItem = item.items.find((line) => line.sOrderlineID === child.sOrderlineID);
            if (matchedItem) {
              matchedIds.add(child.sOrderlineID);
            }
            return {
              ...matchedItem,
              taxAmount: matchedItem?.unittax ?? 0,
              groupedItems: true,
              actualWeight: matchedItem?.weight / mix.weight,
              baseQty: matchedItem?.weight / mix.weight,
            };
          })
          .filter(Boolean);

        return {
          ...mix,
          children: matchedChildren,
          nettotal: mix.nettotal,
          sunitprice: mix.nettotal,
          originalPrice: mix.nettotal,
          salePrice: mix.nettotal - mix.taxAmount,
          realPrice: mix.nettotal - mix.taxAmount,
          addNewLine: "N",
          batchedForSale: "N",
          batchedForStock: "N",
          batchedProduct: "N",
          batchno: null,
          bunitName: "",
          csBunitId: null,
          customAttributes: [],
          cwrMenuTimeslot: [],
          description: "",
          discount: mix.discount,
          discountName: "",
          foodType: "",
          itemType: "",
          grosslist: 0,
          grossstd: 0,
          grossunit: 0,
          hsncode: "",
          imageUrl: "",
          imageurl: "",
          isDecimal: false,
          isDecimalQty: false,
          isManualQty: false,
          restrictPosQtyEdit: "N",
          isPromoApplicable: false,
          isQtyDesimal: mix?.uomData?.[0]?.stdprecision ?? 2,
          isReturn: false,
          key: 0,
          lineId: uuidv4().replace(/-/g, "").toUpperCase(),
          linegross: 0,
          linenet: 0,
          linetax: 0,
          listPrice: 0,
          listprice: 0,
          mBatchId: null,
          mPricingruleId: null,
          multiPrice: "N",
          name2: "",
          netList: 0,
          netStd: 0,
          netunit: 0,
          newCustomAttributes: [],
          order: "N",
          originalPrice: 0,
          priceList: [],
          primaryOrderLine: null,
          productAddons: [],
          productCategoryName: "",
          productId: uuidv4().replace(/-/g, "").toUpperCase(),
          productManufacturerId: null,
          productionCenter: "",
          returnQty: null,
          salesRepId: null,
          salesRepName: "",
          selectedAddons: [],
          shelfLife: "",
          shortDescription: "",
          showAddons: "N",
          taxCategory: "",
          taxFlag: "N",
          taxName: "",
          // taxRate: 18,
          type: "I",
          unitPrice: 0,
          unitTax: 0,
          upc: "",
          upcPricingRule: null,
          value: "",
        };
      });
      const unmatchedItems = item.items.filter((line) => !matchedIds.has(line.sOrderlineID));
      const allItems = [...enrichedMixes, ...unmatchedItems];
      updatedCart = {
        ...itemWithNumberTotal,
        items: allItems,
      };
    }
    const filteredItemsForStockCheck = updatedCart.items.filter((item) => item.productSegment !== "CB" && item.type === "I");
    const stockCart = {
      ...updatedCart,
      items: filteredItemsForStockCheck,
    };
    let stockCheckResult = true;
    let isFinalValidation = false;

    // Navigate-to-invoice helper — single source of truth so all branches behave the same.
    const proceedToInvoice = () => {
      trace("CartDiag", "proceedToInvoice", { itemsLen: updatedCart?.items?.length, preOrder: updatedCart?.preOrder, layAway: updatedCart?.layAway, paid: updatedCart?.paid, total: updatedCart?.total, sOrderID: updatedCart?.sOrderID });
      setShowPreOrders(false);
      setShowPaymentMethods(true);
      setOrderHistoryDetails([]);
      // See useCoreEffects.js's clearStaleCart — on a till with no configured
      // preorderSequence prefix, the mount-time stale-cart guard can't tell this
      // legitimate hand-off apart from a crash leftover and wipes it. This stamp
      // is that guard's escape hatch.
      updatedCart.justRetrievedAt = Date.now();
      setCart(updatedCart);
      setTimeout(() => {
        trace("CartDiag", "history.push /pos", { liveCartLen: useCartStore.getState().cart?.items?.length });
        history.push("/pos");
      }, 300);
    };

    // Only run stock check when: online AND a true preorder (items reserved against stock)
    // AND the till doesn't permit negative stock. Layaway / direct complete-sale flows
    // (preOrder !== "Y") go straight to the invoice screen.
    const canCheckStock = navigator.onLine && updatedCart?.preOrder === "Y" && tillData?.tillAccess?.csBunit?.allowNegativeStock !== "Y";

    if (canCheckStock) {
      stockCheckResult = await stock({
        cart: stockCart,
        setCart,
        tillData,
        setProductStock,
        isFinalValidation,
        setTempCart,
        isCompleteSale: true,
        setShowCompleteSaleStock,
        setCompleteSaleStockData,
      });
      if (!stockCheckResult) {
        setSelectedProductInCart({});
        return;
      }
      proceedToInvoice();
    } else {
      // Layaway complete-sale, offline preorder complete-sale, or allowNegativeStock="Y":
      // skip stock check and route directly to invoice. Previously none of these
      // branches executed, leaving the button non-functional on layaway orders.
      proceedToInvoice();
    }
    setCart(updatedCart);
  };

  const retrieveLayaway = (record, completeOrder) => {
    if (cart.items.length > 0) {
      Modal.confirm({
        title: "Save Cart Items ?",
        icon: <ExclamationCircleOutlined />,
        content: (
          <div>
            You can retrieve the bill later by selecting the 'Retrieve' option in Parked Bills.
            <br />
            Do you want to continue parking the bill?
          </div>
        ),
        okText: "Yes",
        cancelText: "No",
        autoFocusButton: null,
        okButtonProps: { style: { display: "inline-block" } },
        onOk() {
          parkBill();
          upsertPOSLog(cart, "OPK", "Parked");
          const productSearchInput = document.getElementById("sm-product-search");
          if (productSearchInput) {
            setTimeout(() => {
              productSearchInput.focus();
            }, 600);
          }
          setTimeout(() => {
            // selectParkedBill(record, "management");
          }, 2000);
        },
        onCancel() {
          const productSearchInput = document.getElementById("sm-product-search");
          if (productSearchInput) {
            setTimeout(() => {
              productSearchInput.focus();
            }, 300);
          }
          // selectParkedBill(record, "management");
        },
      });
    } else {
      // TSK-2172: Set B2B state and map customer address IDs from salesHistoryDetails
      if (record.b2bOrder === "Y") {
        localStorage.setItem("isB2bEnabled", "true");
        useTransactionStore.getState().setIsB2bEnabled("true");
        try {
          const customerListRaw = record.customer?.customerList;
          if (customerListRaw) {
            const customerList = typeof customerListRaw === "string" ? JSON.parse(customerListRaw) : customerListRaw;
            if (Array.isArray(customerList) && customerList.length > 0) {
              const customer = customerList[0];
              const addresses = customer.customerAddress || [];
              const billingAddr = addresses.find((a) => a.isInvoiceAdd === "Y");
              const shippingAddr = addresses.find((a) => a.isShippingAdd === "Y");
              const customerAddressIds = {
                customerId: customer.sCustomerId,
                billingId: billingAddr?.address_id || null,
                shippingId: shippingAddr?.address_id || null,
              };
              localStorage.setItem("customerAddressIds", JSON.stringify(customerAddressIds));
              if (record.customer) {
                record.customer.customerAddressIds = customerAddressIds;
              }
            }
          }
        } catch (err) {
          console.warn("[TSK-2172] Failed to parse customerList for address mapping:", err?.message);
        }
      } else {
        localStorage.removeItem("isB2bEnabled");
        useTransactionStore.getState().setIsB2bEnabled(null);
      }

      if (completeOrder) {
        selectCompleteLayAwayOrder(record);
      } else {
        selectLayAwayOrder(record);
      }
    }
  };

  const handleButtonClick = () => {
    setPopoverVisible(!isPopoverVisible);
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    const d = dayjs(dateStr);
    return d.isValid() ? d.format("DD-MM-YYYY") : dateStr;
  };

  const getDisplayDate = () => {
    if (dateRange && dateRange.length === 2) {
      const [start, end] = dateRange;
      if (!start && !end) return "Choose date range";
      const startStr = start ? start.format("DD-MM-YYYY") : "";
      const endStr = end ? end.format("DD-MM-YYYY") : "";
      if (startStr || endStr) return `${startStr} to ${endStr}`;
    }
    return "Choose date range";
  };

  const getDeliveryDisplayDate = () => {
    if (deliveryDateRange && deliveryDateRange.length === 2 && deliveryDateRange[0] && deliveryDateRange[1]) {
      const [start, end] = deliveryDateRange;
      return `${start.format("DD-MM-YYYY")} to ${end.format("DD-MM-YYYY")}`;
    }
    return "Choose delivery date range";
  };

  // Shown in the calendar when each popover opens (prefilled with the currently applied
  // range, so the user sees what's active). Deliberately UNCONTROLLED (defaultValue, no
  // value prop) — a controlled value re-synced on every onCalendarChange fights rc-picker's
  // own focus-auto-advance (rc-picker calls selectorRef.focus() internally on each click,
  // then our own re-render with a fresh controlled value undoes it — confirmed by reading
  // rc-picker's RangePicker.js triggerPartConfirm). Each picker's sessionKey is bumped ONLY
  // on that popover's open, forcing a full remount so rc-picker's own internal bookkeeping
  // (useRangeActive's activeListRef — which side has genuinely been visited this session)
  // starts fresh every time. That native mechanism already guarantees the outer onChange
  // only fires once the user has genuinely clicked both the start and end fields — it does
  // NOT fire just because the merged calendarValue momentarily looks complete (e.g. one
  // fresh click + one stale leftover side). An earlier version of this file re-implemented
  // that same "both sides genuinely touched" gate by hand (a discard-and-remount on the
  // first click), but remounting mid-session — while a click on the old DOM was still being
  // processed — raced with the Popover's outside-click detection and intermittently closed
  // the popover after a single click. Trusting rc-picker's native gate and remounting only
  // at the safe, pre-click boundary (popover open) removes that race entirely.
  const [orderDatePickerDefaultValue, setOrderDatePickerDefaultValue] = useState([null, null]);
  const [deliveryDatePickerDefaultValue, setDeliveryDatePickerDefaultValue] = useState([null, null]);
  const [orderDatePickerSessionKey, setOrderDatePickerSessionKey] = useState(0);
  const [deliveryDatePickerSessionKey, setDeliveryDatePickerSessionKey] = useState(0);
  useEffect(() => {
    if (isPopoverVisible) {
      setOrderDatePickerDefaultValue(dateRange && dateRange.length === 2 ? dateRange : [null, null]);
      setOrderDatePickerSessionKey((k) => k + 1);
    }
  }, [isPopoverVisible]);
  useEffect(() => {
    if (deliveryPopoverVisible) {
      setDeliveryDatePickerDefaultValue(deliveryDateRange && deliveryDateRange.length === 2 ? deliveryDateRange : [null, null]);
      setDeliveryDatePickerSessionKey((k) => k + 1);
    }
  }, [deliveryPopoverVisible]);

  const content = (
    <RangePicker
      key={orderDatePickerSessionKey}
      open={isPopoverVisible}
      allowEmpty
      id="sm-salesHistory-date"
      onPressEnter={searchOrderHistory}
      allowClear={true}
      format={"DD-MM-YYYY"}
      suffixIcon={null}
      separator={null}
      defaultValue={orderDatePickerDefaultValue}
      // Render the calendar dropdown inside the Popover content so date clicks
      // are not treated as outside-clicks (which would close the Popover before
      // RangePicker's onChange fires, losing the user's selection).
      getPopupContainer={(trigger) => trigger.parentElement || document.body}
      onCalendarChange={() => {
        // No-op. rc-picker's own bookkeeping (useRangeActive's activeListRef +
        // nextActiveIndex) already guarantees onChange below only fires once the user
        // has genuinely clicked both the start and end fields this session.
      }}
      onChange={(e) => {
        if (e === null) {
          setPopoverVisible(false);
          setFilterdDate(null);
          setDateRange([]);
          setOrderHistoryDetails([]);
          if (searchHistoryInput !== "") {
            searchOrderHistory("customer", searchHistoryInput, 0, false);
          } else {
            db.orders
              .orderBy("orderTime")
              .limit(20)
              .reverse()
              .toArray()
              .then((data) => {
                // Your logic to handle data here
              });
          }
        } else if (e && e[0] && e[1]) {
          // Both sides genuinely picked (allowEmpty can otherwise let a single date
          // count as "done" — reject that here so a lone pick never auto-applies).
          setPopoverVisible(false);
          setFilterdDate(null);
          setDateRange(e);
          localStorage.setItem("dataLength", 0);
          setOrderHistoryDetails([]);
          // Only apply the Delivery Date filter if the user has actually set one.
          // Defaulting the untouched side to "today" incorrectly hid advance orders
          // whose delivery date isn't today (BUG-1929).
          const effectiveDeliveryRange = deliveryDateRange?.length > 0 ? deliveryDateRange : [null, null];
          searchOrderHistory("orderDateSearchKey", e, 0, searchHistoryInput !== "" ? true : false, false, effectiveDeliveryRange);
        }
        // else: partial single-side pick — leave the now-uncontrolled RangePicker to
        // manage its own display; there's no controlled value left to sync.
      }}
      className="salesHistory-datePicker-sm"
    />
  );

  const deliveryContent = (
    <RangePicker
      key={deliveryDatePickerSessionKey}
      open={deliveryPopoverVisible}
      allowEmpty
      allowClear={true}
      format={"DD-MM-YYYY"}
      suffixIcon={null}
      separator={null}
      defaultValue={deliveryDatePickerDefaultValue}
      // Same rc-picker gotcha as the order-date RangePicker above.
      getPopupContainer={(trigger) => trigger.parentElement || document.body}
      onCalendarChange={() => {
        // No-op. rc-picker's own bookkeeping (useRangeActive's activeListRef +
        // nextActiveIndex) already guarantees onChange below only fires once the user
        // has genuinely clicked both the start and end fields this session.
      }}
      onChange={(e) => {
        if (!e || e.every((d) => !d)) {
          setDeliveryPopoverVisible(false);
          setDeliveryDateRange([]);
          setOrderHistoryDetails([]);
        } else if (e?.length === 2 && e[0] && e[1]) {
          // Both sides genuinely picked (allowEmpty can otherwise let a single date
          // count as "done" — reject that here so a lone pick never auto-applies).
          setDeliveryPopoverVisible(false);
          setDeliveryDateRange(e);
          setOrderHistoryDetails([]);
          localStorage.setItem("dataLength", 0);
          // Only apply the Order Date filter if the user has actually set one.
          // Defaulting the untouched side to "today" incorrectly hid advance orders
          // placed on an earlier day even though their delivery date matched (BUG-1929).
          const effectiveOrderRange = dateRange?.length > 0 ? dateRange : [null, null];
          searchOrderHistory("orderDateSearchKey", effectiveOrderRange, 0, searchHistoryInput !== "" ? true : false, false, e);
        }
        // else: partial single-side pick — leave the now-uncontrolled RangePicker to
        // manage its own display; there's no controlled value left to sync.
      }}
      className="salesHistory-datePicker-sm"
    />
  );

  const handleExpand = (record) => {
    const key = record.sOrderID;
    if (!key) return;

    const nextExpandedKeys = [...expandedRowKeys];
    const index = nextExpandedKeys.indexOf(key);

    if (index > -1) {
      nextExpandedKeys.splice(index, 1); // collapse
    } else {
      nextExpandedKeys.push(key); // expand
      getSalesHistoryData(record.sOrderID);
    }

    setExpandedRowKeys(nextExpandedKeys);
  };

  const fetchMoreData = (event) => {
    const lengthOff = parseInt(localStorage.getItem("dataLength")) || 0;
    let previousMaxScroll = maxScroll;
    let previousScroll = currentScroll;
    const newMaxScroll = event.target.scrollHeight - event.target.clientHeight;
    const newCurrentScroll = event.target.scrollTop;

    setMaxScroll(newMaxScroll);
    setCurrentScroll(newCurrentScroll);

    if (scrollLeft !== event.target.scrollLeft) {
      setScrollLeft(event.target.scrollLeft);
      return null;
    }

    if (Math.round(newCurrentScroll) >= Math.round(newMaxScroll) - 1) {
      // The active date filter lives in a dedicated store field, not the sale's
      // orderType, so read it from salesHistoryFilter or pagination never resumes.
      let orderD = useTransactionStore.getState().salesHistoryFilter || [];
      setStartRowData((prevData) => {
        const newStartRow = lengthOff;
        const newEndRow = lengthOff + 20;

        const guardOk =
          orderD.length > 0 &&
          (prevData.startRow !== newStartRow.toString() || prevData.endRow !== newEndRow.toString()) &&
          (previousMaxScroll !== newMaxScroll || previousScroll !== newCurrentScroll) &&
          ordersCopy.length > 0;

        if (guardOk) {
          if (scrollbarsRef.current) {
            scrollbarsRef.current.scrollTop(Math.round(newCurrentScroll) - 5);
          }
          let dateFlag = true;
          if (dateRef.current?.textContent !== "Choose date range") {
            dateFlag = false;
          }

          clearTimeout(debounceTimeoutRef.current);
          debounceTimeoutRef.current = setTimeout(() => {
            setLoading(true);
            // searchOrderHistory advances the dataLength offset itself (absolute), so the
            // next scroll continues from the correct row — no offset bookkeeping needed here.
            searchOrderHistory(orderD[0], orderD[1], lengthOff, true, dateFlag);
          }, 300);
        }

        return {
          startRow: newStartRow.toString(),
          endRow: newEndRow.toString(),
        };
      });
    }
  };

  function arraysAreEqual(arr1, arr2) {
    return JSON.stringify(arr1) === JSON.stringify(arr2);
  }

  useEffect(() => {
    if (orderHistoryDetails.length > 0) {
      const filteredLayawayOrders = orderHistoryDetails.filter((item) => {
        // Cancelled advance orders must not appear in Manage Preorder at all. Cancelling
        // does not clear layAway="Y", so without this a cancelled order still passes the
        // layaway filter below and stays in the list. Drop docstatus="CAN" outright.
        if (item.docstatus === "CAN") return false;
        return posConfig?.advanceLayaway === "Y" ? item.layAway === "Y" : item.layAway === "Y" && item.paid === 0;
      });

      const enrichedLayawayOrders = filteredLayawayOrders.map((item) => ({
        ...item,
        type: item.docstatus === "CAN" ? "Cancelled" : "Layaway",
      }));

      if (!arraysAreEqual(enrichedLayawayOrders, orderHistoryDetails)) {
        setOrderHistoryDetails(enrichedLayawayOrders);
      }
    }
  }, [orderHistoryDetails]);

  useEffect(() => {
    const scrollbars = scrollbarsRef.current?.view;
    if (scrollbars) {
      scrollbars.addEventListener("scroll", fetchMoreData);
      return () => {
        scrollbars.removeEventListener("scroll", fetchMoreData);
      };
    }
  }, [showPreOrders]);

  const orderHistoryColumns = [
    {
      title: "Document Number",
      dataIndex: "documentno",
      key: "documentno",
      width: "20%",
    },
    {
      title: "Date",
      dataIndex: "orderDate",
      key: "orderDate",
      width: "20%",
    },
    {
      title: "Customer",
      key: "customer",
      width: "25%",
      render: (_, record) => record?.customer?.name || "-",
    },
    {
      title: "Total Amount",
      dataIndex: "total",
      key: "total",
      width: "25%",
    },
    {
      title: "Type",
      dataIndex: "type",
      key: "type",
      width: "20%",
      filters: [
        {
          text: "Layaway",
          value: "Layaway",
        },
        {
          text: "Return",
          value: "Return",
        },
        {
          text: "Receipt",
          value: "Receipt",
        },
        {
          text: "Cancelled",
          value: "Cancelled",
        },
      ],
      onFilter: (value, record) => record?.type === value,
      render: (text, record) => {
        let colorStyle;
        switch (record.type) {
          case "Layaway":
            colorStyle = { color: "#007BFF" };
            break;
          case "Return":
            colorStyle = { color: "#f0ad4e" };
            break;
          case "Receipt":
            colorStyle = { color: "#28a745" };
            break;
          case "Cancelled":
            colorStyle = { color: "#000000" };
            break;
          default:
            colorStyle = {};
        }

        return (
          <div style={{ position: "relative" }}>
            <span style={colorStyle}>{text}</span>
            {record.status === "Success" ? (
              <CheckCircleTwoTone
                style={{
                  fontSize: "1rem",
                  cursor: "pointer",
                  marginLeft: "1vw",
                  position: "absolute",
                  right: 1,
                  top: "15%",
                }}
                twoToneColor="#A4CD38"
              />
            ) : (
              <ExclamationCircleTwoTone
                style={{
                  fontSize: "1rem",
                  cursor: "pointer",
                  marginLeft: "1vw",
                  position: "absolute",
                  right: 1,
                  top: "15%",
                }}
                twoToneColor="red"
              />
            )}
          </div>
        );
      },
    },
  ];

  useEffect(() => {
    if (showPreOrders) {
      setTimeout(() => {
        searchCustomersRef?.current?.focus();
      }, 10);
    }
  }, [showPreOrders]);

  // Add these new state variables for cancel order functionality
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [selectedOrderForCancel, setSelectedOrderForCancel] = useState([]);
  const [cancellationReason, setCancellationReason] = useState("");

  return (
    <div style={mainDivStyles}>
      <Spin indicator={<LoadingOutlined style={{ fontSize: 40, marginTop: "18vh", color: "#2F3856" }} spin />} spinning={loading}>
        {showPreOrders ? (
          <>
            <Row
              style={{
                padding: "1.2em 1.5em",
                fontSize: "1vw",
                alignItems: "center",
                gap: "1vw",
              }}
            >
              {/* LEFT HEADER */}
              <Col
                style={{
                  display: "flex",
                  alignItems: "center",
                  minWidth: "18%",
                }}
              >
                <img
                  src={Back || "/placeholder.svg"}
                  id="sm-salesHistory-back"
                  onClick={() => {
                    setShowPreOrders(false);
                    setSearchhistoryInput("");
                    setOrderHistoryDetails([]);
                    setExpandedRowKeys([]);
                    setDateRange([]);
                  }}
                  style={{
                    height: "1.8vw",
                    cursor: "pointer",
                    marginRight: "0.7vw",
                  }}
                />

                <span
                  style={{
                    color: "#0F0718",
                    fontSize: "2em",
                    fontWeight: 600,
                    whiteSpace: "nowrap",
                  }}
                >
                  Manage Pre-Orders
                </span>
              </Col>

              {/* SEARCH */}
              <Col flex={1}>
                <Input
                  ref={searchCustomersRef}
                  placeholder="Search for Customers/Document Number/Contact"
                  prefix={<img src={CustomerSearch || "/placeholder.svg"} style={{ width: "1.2em", opacity: 0.7 }} alt="" />}
                  value={searchHistoryInput}
                  id="sm-salesHistory-customer"
                  allowClear={false}
                  className="salesHistory-input-sm"
                  style={{
                    height: "2.8vw",
                    borderRadius: "10px",
                    border: "1px solid #E5E7EB",
                    background: "#fff",
                    boxShadow: "none",
                  }}
                  onFocus={() => {
                    setOpen(true);
                    setIsInputFocused(true);
                    setInputName("salesHistoryInput");
                  }}
                  onBlur={() => {
                    setIsInputFocused(false);
                  }}
                  onPressEnter={(e) => {
                    if (e.target.value !== "") {
                      // Preserve an active Delivery Date filter too, not just Order Date,
                      // so a combined text + delivery-date search isn't silently dropped (BUG-1929).
                      searchOrderHistory("customer", e.target.value, 0, dateRange?.length > 0 || deliveryDateRange?.length > 0 ? true : false);
                    }
                  }}
                  onChange={async (e) => {
                    let inputVal = e.target.value;
                    setSearchhistoryInput(inputVal);

                    if (inputVal === "" && dateRange?.length === 0) {
                      setOrderHistoryDetails([]);
                    } else if (inputVal === "" && dateRange?.length !== 0) {
                      await setSearchhistoryInput("");
                      searchOrderHistory("orderDateSearchKey", dateRange, 0, false);
                    } else {
                      if (preorderSearchDebounceRef.current) {
                        clearTimeout(preorderSearchDebounceRef.current);
                      }

                      preorderSearchDebounceRef.current = setTimeout(() => {
                        if (inputVal.trim().length >= 2) {
                          // Preserve an active Delivery Date filter too, not just Order Date,
                          // so a combined text + delivery-date search isn't silently dropped (BUG-1929).
                          searchOrderHistory("customer", inputVal.trim(), 0, dateRange?.length > 0 || deliveryDateRange?.length > 0 ? true : false);
                        }
                      }, 350);
                    }
                  }}
                />
              </Col>

              {/* ORDER DATE */}
              <Col>
                <Popover content={content} trigger="click" open={isPopoverVisible} onOpenChange={(visible) => setPopoverVisible(visible)}>
                  <Button
                    icon={<CalendarOutlined />}
                    onClick={handleButtonClick}
                    ref={dateRef}
                    style={{
                      height: "2.8vw",
                      minWidth: "16vw",
                      borderRadius: "10px",
                      border: "1px solid #E5E7EB",
                      background: "#fff",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "flex-start",
                      color: "#6B7280",
                      fontWeight: 500,
                      boxShadow: "none",
                    }}
                  >
                    {getDisplayDate()}
                  </Button>
                </Popover>
              </Col>

              {/* DELIVERY DATE */}
              <Col>
                <Popover content={deliveryContent} trigger="click" open={deliveryPopoverVisible} onOpenChange={(visible) => setDeliveryPopoverVisible(visible)}>
                  <Button
                    icon={<CalendarOutlined />}
                    onClick={() => setDeliveryPopoverVisible(!deliveryPopoverVisible)}
                    style={{
                      height: "2.8vw",
                      minWidth: "18vw",
                      borderRadius: "10px",
                      border: "1px solid #E5E7EB",
                      background: "#fff",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "flex-start",
                      color: "#6B7280",
                      fontWeight: 500,
                      boxShadow: "none",
                    }}
                  >
                    {getDeliveryDisplayDate()}
                  </Button>
                </Popover>
              </Col>
            </Row>

            <Scrollbars style={{ height: "78vh" }} ref={scrollbarsRef}>
              {orderHistoryDetails.map((record) => {
                return (
                  <div
                    style={{
                      border: "1px solid #92909895",
                      margin: "0 2vw 2vh 2vw",
                      borderRadius: "5px",
                      padding: "15px 20px",
                      marginBottom: "10px",
                      backgroundColor: "#fff",
                      fontSize: "1vw",
                    }}
                  >
                    <div>
                      <Row>
                        <Col span={12}>
                          <p style={{ fontWeight: 600, fontSize: "1.35em", display: "flex", alignItems: "center", gap: "8px", color: "#0F0718", marginBottom: 0 }}>
                            Document No: {record.documentno}
                          </p>
                        </Col>
                        <Col span={12} style={{ textAlign: "right" }}>
                          <div
                            style={{
                              color:
                                record.type === "Layaway"
                                  ? "#007BFF"
                                  : record.type === "Return"
                                    ? "#f0ad4e"
                                    : record.type === "Receipt"
                                      ? "#28a745"
                                      : record.type === "Cancelled"
                                        ? "#000000"
                                        : undefined,
                              display: "inline-flex",
                              borderRadius: "3px",
                              alignItems: "center",
                              gap: "8px",
                              marginLeft: "1vw",
                              fontSize: "15px",
                              marginBottom: 0,
                            }}
                          >
                            {record.type}
                            {record.status === "Success" ? <CheckCircleTwoTone twoToneColor="#A4CD38" /> : <ExclamationCircleTwoTone twoToneColor="red" />}
                          </div>
                        </Col>
                      </Row>
                      {posConfig?.showEstimateNoInSalesHistory === "Y" && record?.estimateDocumentNo && (
                        <Row>
                          <Col span={12}>
                            <p style={{ fontWeight: 600, fontSize: "1.35em", display: "flex", alignItems: "center", gap: "8px", color: "#0F0718", marginBottom: 0 }}>
                              Estimate No: {record?.estimateDocumentNo}
                            </p>
                          </Col>
                        </Row>
                      )}
                      <Row>
                        <Col span={12}>
                          <p style={{ color: "#0F0718", fontSize: "1em", fontWeight: 500, marginTop: "1vh", marginBottom: 0 }}>
                            <CalendarOutlined style={{ marginRight: "0.3em" }} />
                            Delivery Date: {formatDate(record.deliveryDate)}
                          </p>
                        </Col>
                      </Row>
                      <Row>
                        <Col span={12}>
                          <p style={{ color: "#0F0718", fontSize: "1em", fontWeight: 500, marginTop: "1vh", marginBottom: 0, color: "#929098" }}>
                            <CalendarOutlined style={{ marginRight: "0.3em", color: "#929098" }} />
                            Order Date: {formatDate(record.orderDate)}
                          </p>
                        </Col>
                        <Col span={12} style={{ textAlign: "right" }}>
                          <p style={{ color: "#0F0718", fontWeight: 500, fontSize: "1.15em", marginTop: "1vh", marginBottom: 0 }}>Qty: {record.totalQty}</p>
                        </Col>
                      </Row>
                      <Row align="middle">
                        <Col span={16}>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "2em",
                              marginTop: "0.6vh",
                            }}
                          >
                            <p
                              style={{
                                color: "#0F0718",
                                fontSize: "1em",
                                fontWeight: 500,
                                marginBottom: 0,
                                display: "flex",
                                alignItems: "center",
                              }}
                            >
                              <UserOutlined style={{ marginRight: "0.3em" }} />
                              Customer: {record.customer?.name}
                            </p>
                            {record.customer?.mobileNo && (
                              <p
                                style={{
                                  color: "#0F0718",
                                  fontSize: "1em",
                                  fontWeight: 500,
                                  marginBottom: 0,
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                <PhoneOutlined style={{ marginRight: "0.3em" }} />
                                Mobile No: {record.customer?.mobileNo || ""}
                              </p>
                            )}
                          </div>
                        </Col>

                        <Col span={8} style={{ textAlign: "right" }}>
                          <p
                            style={{
                              color: "#0F0718",
                              fontWeight: 500,
                              fontSize: "1.15em",
                              marginTop: "0.6vh",
                              marginBottom: 0,
                            }}
                          >
                            Total: {currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""}
                            {record.total}
                            {currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : ""}
                          </p>
                        </Col>
                      </Row>
                    </div>
                    <Row style={{ marginTop: "2vh" }} gutter={12}>
                      <Col>
                        <Button
                          style={{ borderRadius: "4px", color: "#0F0718", fontWeight: 500 }}
                          onClick={async () => {
                            setRecordId(record.sOrderID);
                            const details = await getSalesHistoryData(record.sOrderID);
                            setRecordDetails(details[0]);
                            setViewDetails(true);
                          }}
                        >
                          <EyeOutlined />
                          View Details
                        </Button>
                      </Col>
                      {record.docstatus !== "CAN" && (
                        <>
                          <Col>
                            <Button
                              style={{ borderRadius: "4px", color: "#0F0718", fontWeight: 500 }}
                              onClick={async () => {
                                // Hard guard: a cancelled order must never be retrievable, even if
                                // this button is somehow reached from stale state. The visibility
                                // guard (docstatus !== "CAN") hides the button; this blocks the action.
                                if (record.docstatus === "CAN") {
                                  message.error("This order has been cancelled and can no longer be processed.");
                                  return;
                                }
                                const currentParkedList = useSessionStore.getState().parkedList || [];
                                const isDocnoInList = currentParkedList.some((item) => item.parkedDocNo === record.documentno);
                                if (isDocnoInList) {
                                  Modal.info({
                                    title: "This layaway order is already parked. Please access it from the bill parking area to continue.",
                                    icon: null,
                                    cancelText: "No",
                                    okText: "Okay",
                                    autoFocusButton: null,
                                    okButtonProps: { style: { display: "inline-block" } },
                                  });
                                } else {
                                  setShowPreOrders(false);
                                  const details = await getSalesHistoryData(record.sOrderID);
                                  const data = details[0];
                                  data.docType = "Advance";
                                  data.type = "Layaway";
                                  retrieveLayaway(data, false);
                                  setSelectedDocumentType("Advance");
                                  setOrderHistoryDetails([]);
                                  setExpandedRowKeys([]);
                                  setSearchhistoryInput("");
                                  const saleData = await db.posSaletypes.toArray();
                                  saleData.map((item) => {
                                    if (item.cwrSaletype.cwrSaletypeId === data.saleType.cwrSaletypeId) {
                                      setSelectedSaleTypeData(item);
                                      usePOSConfigStore.getState().setSaleTypeData(item);
                                      setSelectedSaleType(item?.cwrSaletype?.name);
                                    }
                                  });
                                  let paymentDetails = getFilteredPaymentMethods(data?.saleType?.cwrSaletypeId || null);
                                  let payments =
                                    paymentDetails.length > 5
                                      ? sortBy(paymentDetails, "sequenceNo").slice(
                                          0,
                                          tillData?.tillAccess?.csBunit?.b2cCustomer?.cwrCustomerId === data?.customer?.cwrCustomerId && paymentDetails.length === 5 ? 4 : 4
                                        )
                                      : paymentDetails;
                                  setStartIndex(payments.length);
                                  setShowPayments(payments);
                                }
                              }}
                            >
                              <ShoppingCartOutlined />
                              Retrieve Order
                            </Button>
                          </Col>
                          <Col>
                            <Button
                              style={{ borderRadius: "4px", color: "#fff", fontWeight: 500, backgroundColor: "#2F3856" }}
                              onClick={async () => {
                                // Hard guard: a cancelled order must never reach Complete Sale, even
                                // if this button is somehow reached from stale state. The visibility
                                // guard (docstatus !== "CAN") hides the button; this blocks the action.
                                if (record.docstatus === "CAN") {
                                  message.error("This order has been cancelled and can no longer be processed.");
                                  return;
                                }
                                const currentParkedList = useSessionStore.getState().parkedList || [];
                                const isDocnoInList = currentParkedList.some((item) => item.parkedDocNo === record.documentno);
                                if (isDocnoInList) {
                                  Modal.info({
                                    title: "This layaway order is already parked. Please access it from the bill parking area to continue.",
                                    icon: null,
                                    cancelText: "No",
                                    okText: "Okay",
                                    autoFocusButton: null,
                                    okButtonProps: { style: { display: "inline-block" } },
                                  });
                                } else {
                                  const details = await getSalesHistoryData(record.sOrderID);
                                  const detail = details[0];
                                  const advanceItem = detail.items.find(
                                    (item) =>
                                      item.type === "S" &&
                                      item.weight > 0 &&
                                      posConfig?.AllowServiceItemsinAdvanceOrderCompletion === "N" &&
                                      !posConfig?.AllowServiceItemsinAdvanceOrderCompletion
                                  );
                                  detail.docType = "Invoice";
                                  detail.type = "Layaway";
                                  const data = {
                                    ...detail,
                                    preOrder: "Y",
                                  };
                                  retrieveLayaway(data, true);
                                  setSelectedDocumentType("Invoice");
                                  setExpandedRowKeys([]);
                                  setSearchhistoryInput("");
                                  const saleData = await db.posSaletypes.toArray();
                                  saleData.map((item) => {
                                    if (item.cwrSaletype.cwrSaletypeId === detail.saleType.cwrSaletypeId) {
                                      setSelectedSaleTypeData(item);
                                      usePOSConfigStore.getState().setSaleTypeData(item);
                                      setSelectedSaleType(item?.cwrSaletype?.name);
                                    }
                                  });
                                  let paymentDetails = getFilteredPaymentMethods(detail?.saleType?.cwrSaletypeId || null);
                                  let payments =
                                    paymentDetails.length > 5
                                      ? sortBy(paymentDetails, "sequenceNo").slice(
                                          0,
                                          tillData?.tillAccess?.csBunit?.b2cCustomer?.cwrCustomerId === detail?.customer?.cwrCustomerId && paymentDetails.length === 5 ? 4 : 4
                                        )
                                      : paymentDetails;
                                  setStartIndex(payments.length);
                                  setShowPayments(payments);
                                }
                              }}
                            >
                              <CreditCardOutlined />
                              Complete Sale
                            </Button>
                          </Col>
                          <Col style={{ marginLeft: "auto" }}>
                            <Dropdown
                              overlay={
                                <Menu>
                                  <Menu.Item
                                    key="print"
                                    icon={<PrinterOutlined />}
                                    onClick={async () => {
                                      const details = await getSalesHistoryData(record.sOrderID);
                                      const detail = { ...details[0], orderCompleted: false };
                                      const { workflowRules, approvers } = await getWorkflowData();
                                      if (workflowRules && workflowRules.length > 0) {
                                        workflowRules.forEach((res) => {
                                          if (res.eventName === "Receipt Reprint Request") {
                                            dispatchEvent(res.eventName, res.ruleName, res.ruleCondition, approvers, null, (eventData) => {
                                              if (eventData?.approvalGranted) {
                                                const reprintDetail = { ...detail, isReprint: true };
                                                ObFlag
                                                  ? HCPrint(reprintDetail, "Duplicate Copy")
                                                  : CWHardwareController
                                                    ? CWHCPrint(reprintDetail, "Duplicate Copy")
                                                    : isPrintModeXML
                                                      ? xmlPrint(reprintDetail, "Duplicate Copy")
                                                      : htmlPrint(reprintDetail, "Duplicate Copy");
                                              }
                                            });
                                          }
                                        });
                                      } else {
                                        const reprintDetail = { ...detail, isReprint: true };
                                        ObFlag
                                          ? HCPrint(reprintDetail, "Duplicate Copy")
                                          : CWHardwareController
                                            ? CWHCPrint(reprintDetail, "Duplicate Copy")
                                            : isPrintModeXML
                                              ? xmlPrint(reprintDetail, "Duplicate Copy")
                                              : htmlPrint(reprintDetail, "Duplicate Copy");
                                        upsertPOSLog(detail, "RRC");
                                      }
                                    }}
                                  >
                                    Print Receipt
                                  </Menu.Item>
                                  <Menu.Item
                                    key="cancel"
                                    icon={<CloseCircleOutlined style={{ color: "#da1b1bff" }} />}
                                    onClick={async () => {
                                      const details = await getSalesHistoryData(record.sOrderID);
                                      setSelectedOrderForCancel(details);
                                      setShowCancelModal(true);
                                    }}
                                  >
                                    <span style={{ color: "#da1b1bff", fontWeight: "500" }}>Cancel Order</span>
                                  </Menu.Item>
                                </Menu>
                              }
                              trigger={["click"]}
                            >
                              <Button style={{ borderRadius: "3px", fontWeight: "500", color: "#0F0718" }}>
                                More Actions <EllipsisOutlined style={{ color: "#0F0718" }} />
                              </Button>
                            </Dropdown>
                          </Col>
                        </>
                      )}
                    </Row>
                  </div>
                );
              })}
            </Scrollbars>
          </>
        ) : null}

        <Modal open={viewDetails} onCancel={() => setViewDetails(false)} destroyOnHidden={true} title={null} footer={null} width={600} styles={{ body: { borderRadius: "8px" } }}>
          <div style={{ display: "flex", alignItems: "center", height: "2vh", fontSize: "1vw", marginTop: "1vh" }}>
            <p style={{ fontSize: "1.5em", fontWeight: "500", color: "#0F0718", flex: 1 }}>Order Details</p>
          </div>

          <div style={{ border: "1px solid #92909895", height: "20vh", padding: "10px", margin: "15px", borderRadius: "5px" }}>
            <Row>
              <Col span={6} style={{ display: "flex", justifyContent: "center", color: "#0F0718", fontSize: "1em", fontWeight: 600 }}>
                Order Items
              </Col>
              <Col span={6} style={{ display: "flex", justifyContent: "center", color: "#0F0718", fontSize: "1em", fontWeight: 600 }}>
                Qty
              </Col>
              <Col span={6} style={{ display: "flex", justifyContent: "center", color: "#0F0718", fontSize: "1em", fontWeight: 600 }}>
                Unit Price
              </Col>
              <Col span={6} style={{ display: "flex", justifyContent: "center", color: "#0F0718", fontSize: "1em", fontWeight: 600 }}>
                Net Total
              </Col>
            </Row>
            <Scrollbars style={{ height: "15vh" }}>
              <div style={{ padding: "0 16px 16px 16px", fontSize: "1vw" }}>
                {recordDetails?.items?.map((item, index) => (
                  <div key={index} style={{ marginBottom: "20px" }}>
                    <Row style={{ marginTop: "1vh" }}>
                      <Col span={6}>{item.name}</Col>
                      <Col span={6} style={{ display: "flex", justifyContent: "center" }}>
                        {item.weight}
                      </Col>
                      <Col span={6} style={{ display: "flex", justifyContent: "center" }}>
                        {item.salePrice}
                      </Col>
                      <Col span={6} style={{ display: "flex", justifyContent: "center" }}>
                        {item.nettotal}
                      </Col>
                    </Row>
                  </div>
                ))}
              </div>
            </Scrollbars>
          </div>

          {/* <div style={{ display: "flex", alignItems: "center", fontSize: "1vw", marginTop: "2vh" }}>
          <p style={{ fontSize: "1.5em", fontWeight: "500", color: "#0F0718", flex: 1 }}>Payment Information</p>
        </div> */}
          {/* <Row gutter={[16, 8]} style={{ margin: "0px 10px 0px 10px" }}>
            <Col span={8}>
              <p style={{ fontWeight: 600, color: "#0F0718", marginBottom: 0 }}>Payment Method</p>
            </Col>
            <Col span={8}>
              <p style={{ fontWeight: 600, color: "#0F0718", marginBottom: 0 }}>Amount</p>
            </Col>
            <Col span={8}>
              <p style={{ fontWeight: 600, color: "#0F0718", marginBottom: 0 }}>Advance Payment</p>
            </Col>

            {recordDetails?.paymentData?.map((data, index) => (
              <React.Fragment key={index}>
                <Col span={8}>
                  <p style={{ marginBottom: 0, color: "#0F0718", fontWeight: 500 }}>{data.name}</p>
                </Col>
                <Col span={8}>
                  <p style={{ marginBottom: 0, color: "#0F0718", fontWeight: 500 }}>{data.amount}</p>
                </Col>
                <Col span={8}>
                  <p style={{ marginBottom: 0, color: "#0F0718", fontWeight: 500 }}>
                    {recordDetails?.advancePayment > 0 && recordDetails?.layAway === "Y" ? recordDetails?.advancePayment : 0}
                  </p>
                </Col>
              </React.Fragment>
            ))}
          </Row> */}
          <Row gutter={[16, 8]} style={{ margin: "0px 10px 0px 10px" }}>
            <Col span={12}>
              <p style={{ fontWeight: 600, color: "#0F0718", marginBottom: 0 }}>Payment Method</p>
            </Col>
            <Col span={12}>
              <p style={{ fontWeight: 600, color: "#0F0718", marginBottom: 0 }}>Amount</p>
            </Col>

            {recordDetails?.paymentData?.map((data, index) => (
              <React.Fragment key={index}>
                <Col span={12}>
                  <p style={{ marginBottom: 0, color: "#0F0718", fontWeight: 500 }}>{data.name}</p>
                </Col>
                <Col span={12}>
                  <p style={{ marginBottom: 0, color: "#0F0718", fontWeight: 500 }}>{data.amount}</p>
                </Col>
              </React.Fragment>
            ))}
            {recordDetails?.advancePayment > 0 && recordDetails?.layAway === "Y" && (
              <Col span={24}>
                <div
                  style={{
                    display: "flex",
                    marginTop: "8px",
                    borderTop: "1px solid #ddd",
                    paddingTop: "8px",
                    alignItems: "center",
                  }}
                >
                  <p style={{ fontWeight: 600, color: "#0F0718", marginBottom: 0 }}>Advance Payment</p>
                  <p style={{ fontWeight: 600, color: "#0F0718", marginBottom: 0, marginLeft: "2.5vw" }}>{recordDetails.advancePayment}</p>
                </div>
              </Col>
            )}
          </Row>

          <Row gutter={[16, 8]} style={{ margin: "10px", marginTop: "2vh" }}>
            <Col span={6}>
              <p style={{ marginBottom: 0, color: "#0F0718", fontWeight: 600, fontSize: "1em" }}>Subtotal</p>
            </Col>
            <Col span={6}>
              <p style={{ marginBottom: 0, color: "#0F0718", fontWeight: 500, fontSize: "1em" }}>
                {recordDetails?.total && recordDetails?.tax ? (recordDetails.total - recordDetails.tax).toFixed(pricePrecision) : "0.00"}
              </p>
            </Col>
            <Col span={12}>
              <p style={{ marginBottom: 0, color: "#0F0718", fontWeight: 600, fontSize: "1em", textAlign: "center" }}>SALE TOTAL</p>
            </Col>
          </Row>

          <Row gutter={[16, 8]} style={{ margin: "10px" }}>
            <Col span={6}>
              <p style={{ marginBottom: 0, color: "#0F0718", fontWeight: 600, fontSize: "1em" }}>Total Tax</p>
            </Col>
            <Col span={6}>
              <p style={{ marginBottom: 0, color: "#0F0718", fontWeight: 500, fontSize: "1em" }}>{recordDetails?.tax ? recordDetails.tax.toFixed(pricePrecision) : "0.00"}</p>
            </Col>
            <Col span={12} style={{ marginBottom: 0, color: "#0F0718", fontWeight: 500, fontSize: "1em", textAlign: "center" }}>
              <p style={{ marginBottom: 0, color: "#0F0718", fontWeight: 500, fontSize: "1em", textAlign: "center" }}>
                {parseFloat(recordDetails.total).toFixed(tillData.tillAccess.csBunit.currencies[0].prcPrecision)}
              </p>
            </Col>
          </Row>
        </Modal>
        <Modal
          open={showCancelModal}
          onCancel={() => {
            setShowCancelModal(false);
            setSelectedOrderForCancel([]);
            setCancellationReason("");
          }}
          destroyOnHidden={true}
          title={null}
          footer={null}
          width={450}
          centered={true}
          style={{ borderRadius: "20px" }} // Increased border radius
          styles={{ body: { padding: "25px", minHeight: selectedOrderForCancel[0]?.advancePayment > 0 ? "440px" : "330px" } }} // Increased height via minHeight
          closeIcon={<CloseOutlined style={{ fontSize: "16px", color: "#666" }} />}
        >
          <div>
            <h2
              style={{
                color: "#dc3545",
                fontSize: "16px",
                fontWeight: "600",
                marginTop: 0,
              }}
            >
              Cancel Order
            </h2>

            <div
              style={{
                backgroundColor: "rgb(254 242 242 / var(--tw-bg-opacity, 1))",
                border: "1px solid rgb(254 202 202 / var(--tw-border-opacity, 1))",
                borderRadius: "8px",
                padding: "14px",
                marginBottom: "14px",
              }}
            >
              <div style={{ color: "rgb(185 28 28 / var(--tw-text-opacity, 1))", fontSize: "13px", lineHeight: "1.5" }}>
                <div
                  style={{
                    color: "rgb(153 27 27 / var(--tw-text-opacity, 1))",
                    fontSize: "13px",
                    marginTop: 0,
                  }}
                >
                  Order Details
                </div>
                <div>Order ID: {selectedOrderForCancel[0]?.documentno}</div>
                <div>Customer: {selectedOrderForCancel[0]?.customer?.name || ""}</div>
                <div>
                  Advance Paid: {currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""}
                  {selectedOrderForCancel[0]?.advancePayment || "0.00"}
                  {currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : ""}
                </div>
              </div>
            </div>

            <div>
              <label
                style={{
                  display: "block",
                  color: "#333",
                  fontSize: "13px",
                  fontWeight: "500",
                  marginBottom: "8px",
                }}
              >
                Cancellation Reason
              </label>
              <Input.TextArea
                placeholder="Enter reason for cancellation..."
                value={cancellationReason}
                onChange={(e) => setCancellationReason(e.target.value)}
                rows={4}
                style={{
                  fontSize: "12px",
                  borderRadius: "8px",
                  marginBottom: "14px",
                }}
              />
            </div>
            {selectedOrderForCancel[0]?.advancePayment > 0 && (
              <div
                style={{
                  backgroundColor: "rgb(254 252 232 / var(--tw-bg-opacity, 1))",
                  border: "1px solid rgb(254 240 138 / var(--tw-border-opacity, 1))",
                  borderRadius: "8px",
                  padding: "8px",
                  marginBottom: "14px",
                }}
              >
                <div style={{ color: "#856404", fontSize: "13px", lineHeight: "1.5" }}>
                  <strong>Note:</strong> This will cancel the order and process a full refund of {currenciesList[0].symbolRightSide === "N" ? currenciesList[0].currSymbol : ""}
                  {selectedOrderForCancel[0]?.advancePayment || "0.00"}
                  {currenciesList[0].symbolRightSide === "Y" ? currenciesList[0].currSymbol : ""}.
                </div>
              </div>
            )}

            <div
              style={{
                display: "flex",
                gap: "12px",
                width: "100%",
              }}
            >
              <Button
                style={{
                  borderRadius: "6px",
                  fontWeight: "500",
                  width: "50%", // Half width of the modal
                  fontSize: "12px",
                  height: "40px",
                }}
                onClick={() => {
                  setShowCancelModal(false);
                  setSelectedOrderForCancel([]);
                  setCancellationReason("");
                }}
              >
                Keep Order
              </Button>
              <Button
                type="primary"
                danger
                style={{
                  borderRadius: "6px",
                  fontWeight: "500",
                  width: "50%", // Half width of the modal
                  fontSize: "12px",
                  backgroundColor: "#dc3545",
                  borderColor: "#dc3545",
                  height: "40px",
                }}
                onClick={async () => {
                  const cancelledOrderId = selectedOrderForCancel[0]?.sOrderID;
                  const result = await cancelPreorder(cancelledOrderId, cancellationReason);
                  setShowCancelModal(false);
                  setSelectedOrderForCancel([]);
                  setCancellationReason("");
                  if (result?.status === "200") {
                    message.success("Order cancelled successfully");
                    // The cancel happens in-session and the list is NOT re-fetched, so the
                    // just-cancelled record still carries its pre-cancel docstatus. Patch it
                    // locally to "CAN"/"Cancelled" so the docstatus guard (Retrieve Order /
                    // Complete Sale / More Actions) hides those actions immediately, matching
                    // the state a fresh server reload would produce.
                    const markCancelled = (list) =>
                      (list || []).map((order) => (order.sOrderID === cancelledOrderId ? { ...order, docstatus: "CAN", type: "Cancelled" } : order));
                    setOrderHistoryDetails(markCancelled);
                    setOrdersCopy(markCancelled);
                  } else {
                    message.error(result?.message || `${messages.errors.orders.cancelled_failed}`);
                  }
                }}
              >
                {selectedOrderForCancel[0]?.advancePayment > 0 ? "Cancel & Refund" : "Cancel Order"}
              </Button>
            </div>
          </div>
        </Modal>
      </Spin>
    </div>
  );
};
export default ManagePreorder;
